// noinspection DuplicatedCode
import { addLoginQueryParams } from '../utils/url';
import { Locker } from '../utils/locker';
import { windowOpen } from '../utils/window';


export function initFbSdk(): void {
    try {
        window.app.fb_login = fbLoginButtonHandler;
    } catch (error) {
        console.warn('fb not initialized', error);
    }
}

function fbLoginButtonHandler() {
    const lockKey = 'fb:login';
    const locker = Locker.getInstance();
    if (!locker.setTempLock(lockKey, 5000)) {
        return;
    }

    try {
        callAppFbLoginProcess();
    } catch (error) {
        console.warn(error);
        locker.releaseLock(lockKey);
    }
}

function callAppFbLoginProcess() {
    let url;

    url = window.app.config.fb.oauth_url + window.location.search;
    url = addLoginQueryParams(url);
    windowOpen(url, 600, 600);
}
